var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"trick-list"},_vm._l((_vm.tricks),function(trick){return _c('li',{key:trick.id,staticClass:"trick"},[_c(_vm.trickType,_vm._b({tag:"component",nativeOn:{"click":function($event){return _vm.$emit('trick-selected', trick)}}},'component',trick,false))],1)}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bed95c1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/game/shop/TrickList.vue
// module id = null
// module chunks = 